export async function ConspretratamientoUpdate(
  conspretResp,
  metaFecha,
  conspretMedio,
  conspretTipo,
  conspretObs,
  tratamientoId,
  pacienteId,
  conspretratId
) {
  const formData = {
    // taxID-mind-mindNumses
    title: `us-${pacienteId}-tr-${tratamientoId}-conspret-${metaFecha}`,
    slug: `us-${pacienteId}-tr-${tratamientoId}-conspret-${metaFecha}`,
    status: "publish",
    tratamiento: tratamientoId,
    paciente: pacienteId,
    meta: {
      conspretResp: conspretResp,
      metaFecha: metaFecha,
      conspretMedio: conspretMedio,
      conspretTipo: conspretTipo,
      conspretObs: conspretObs,
    },
  };

  const authToken = sessionStorage.getItem("token");

  try {
    const response = await fetch(
      `https://app.tavad.com/hce/wp-json/wp/v2/conspretrat/${conspretratId}`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(formData),
      }
    );
    const values = await response.json();
    console.log(values);
    return values;
  } catch (error) {
    console.error(error);
  }
}
